import { convertUnitsFinal } from "../../../../utils/dataAndFormulas/wasteForms";

export const nonHazardousTypes = {
  paper_and_cardboard: "Papel y cartón",
  plastic: "Plástico",
  fabric_scraps: "Tela o retazos",
  metal_clean: "Metal limpio",
  wood: "Madera",
  food_waste: "Restos de comida",
  general_trash: "Basura general",
  glass: "Vidrio",
  leather: "Cuero",
  foam_eva: "Espuma (EVA)",
  empty_cans_or_containers: "Latas vacías",
  rubber: "Caucho",
  other_non_hazardous_waste: "Otros",
};

export const hazardousTypes = {
  electronic_waste: "Residuos electrónicos",
  empty_chemical_containers: "Envases vacíos Químicos",
  cleaning_pesticide_containers: "Envases de limpieza y pesticidas",
  batteries: "Baterías",
  fluorescent_tubes: "Tubos fluorescentes",
  cooking_oil: "Aceite de cocina",
  maintenance_oil: "Aceite de mantenimiento",
  lubricants: "Lubricantes",
  paint_waste: "Restos de pinturas",
  coal_ashes: "Cenizas de carbón",
  rubber_hazardous: "Caucho",
  chemicals: "Químicos",
  contaminated_materials: "Materiales contaminados",
  ink_cartridges: "Cartuchos de tinta",
  medical_waste: "Residuos médicos (patogénicos)",
  other_hazardous_waste: "Otros ",
};

// "metal_clean" trae un texto largo pensado para el formulario ("Metal
// (agujas o virutas no contaminadas)") — ahí la aclaración importa, pero
// como etiqueta de eje de este gráfico solo hace falta "Metal". En vez de
// acortar la traducción de "metal_clean" (usada en formularios/tablas en
// otros lugares del módulo), se pisa solo acá con una clave nueva.
const CHART_LABEL_KEY_OVERRIDES = {
  metal_clean: "metal_clean_chart_label",
  other_non_hazardous_waste: "other_non_hazardous_waste_chart_label",
};

// Ventana fija de años (año actual y los 2 anteriores) — misma que usan
// WasteComparisonChart/WasteComparisonChartPeligrosos en pantalla.
function getComparisonYears() {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 3 }, (_, i) => String(currentYear - 2 + i));
}

function buildComparisonData(typesDict, resultsByYear, valueBaseline, t) {
  const years = getComparisonYears();

  const activeTypes = Object.entries(typesDict)
    .filter(([key]) =>
      years.some((year) => (resultsByYear[key]?.[year]?.total || 0) > 0),
    )
    .map(([key]) => key);

  const barData = [];
  years.forEach((year) => {
    activeTypes.forEach((key) => {
      const total = resultsByYear[key]?.[year]?.total || 0;
      const unit = resultsByYear[key]?.[year]?.unit || "kg";
      const valueInKg = convertUnitsFinal(total, unit, "kg");
      const value = valueBaseline[year] ? valueInKg / valueBaseline[year] : 0;
      if (value > 0) {
        const labelKey = CHART_LABEL_KEY_OVERRIDES[key] || key;
        barData.push({ year: String(year), type: t(labelKey), value });
      }
    });
  });

  return { years, barData };
}

export function buildWasteComparisonData(resultsByYear, valueBaseline, t) {
  return buildComparisonData(nonHazardousTypes, resultsByYear, valueBaseline, t);
}

export function buildWasteComparisonDataPeligrosos(resultsByYear, valueBaseline, t) {
  return buildComparisonData(hazardousTypes, resultsByYear, valueBaseline, t);
}
